import { Pipe, PipeTransform } from '@angular/core';
import moment from "moment";

@Pipe({
    name: 'unixToCentralTime',
    standalone: false
})
export class UnixToCentralTimePipe implements PipeTransform {
  transform(unixTime: number): string {
    const centralTime = moment.tz(unixTime,'America/Chicago');
    var formatted = centralTime.format('MM/DD/YYYY HH:mm');
    if(formatted == "Invalid date"){
        return
    }
    return formatted
  }
}
